module.exports = __webpack_public_path__ + "airfloss_ultra.9f3da927d50e6798651a.png";


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/assets/images/orthokit/airfloss_ultra.png
// module id = ../../../../../src/assets/images/orthokit/airfloss_ultra.png
// module chunks = main